import { TaskStatus, OverriddenTaskStatus } from '~/types';

export const SELECTED_TASK_STATUS = {
  CALCULATED_BY_TIME_ENTRIES: 'CALCULATED_BY_TIME_ENTRIES',
  COMPLETED: TaskStatus.Completed,
  MANUAL_NOT_STARTED: OverriddenTaskStatus.ManualNotStarted,
  MANUAL_IN_PROGRESS: OverriddenTaskStatus.ManualInProgress
};
